export const MATERIAL_OPTIONS: string[] = [
    "N BUTANOL (170 KG)",
    "ADDITIVES",
    "ADHESIVE SF2273A",
    "ADHESIVE SF9180A",
    "ADHESIVE SF9180B",
    "ALUMINIUM FOIL",
    "BLOOD RED",
    "BOPP METALIZED[795X18MU]",
    "C BOPP",
    "CLEAR 720 X40 MU",
    "CLEAR BOPP",
    "CLEAR BOPP [1010mm X 18μm]",
    "CLEAR BOPP [1025mm X 18μm]",
    "CLEAR BOPP [575 X18 MU ]",
    "CLEAR BOPP [580mm X 18μm]",
    "CLEAR BOPP [720mm X 40μm]",
    "CLEAR BOPP [930mm X 18μm]",
    "CLEAR BOPP [975mm X 18μm]",
    "CLEAR BOPP[1020 X 40MU]",
    "CLEAR BOPP[1025X18MU]",
    "CLEAR BOPP[720X 40MU]",
    "CLEAR BOPP[820 X18MU]",
    "CLEAR BOPP[820mmx18MU]",
    "CLEAR BOPP[880mm x40 MU]",
    "CLEAR BOPP[885 X18MU]",
    "CLEAR BOPP[895 X18MU]",
    "CLEAR BOPP[920X30MU]",
    "CLEAR BOPP[980X40MU]",
    "CLEAR CPP",
    "CLEAR CPP [610mm X 35μm]",
    "CLEAR CPP [915mm X 35μm]",
    "CLEAR PET",
    "DIOXALANE",
    "DURABLE CONS",
    "ENABLE",
    "ENABLE-EXXON2703HH(MC)",
    "EP-PROCESSING AID PA44",
    "FILM-BOPP METALIZED 795X18MU",
    "FILM-BOPP PEARLIZED 820X38MU",
    "FILM-BOPP PEARLIZED(820X38MU)",
    "FILM-PET G 825X45",
    "FOODS",
    "FRUITS",
    "GL -1.3 DIOXALANE",
    "GL -ADHESIVE LOCTITE CAC SF 29 (NCO)",
    "GL -SI -5001 BOPP ADHESION PROMOTER",
    "GL BRILLIANT HARDENER OH S110(230KG)",
    "GL-ADHESION BOPP PROMOTER",
    "GL-ADHESIVE LOCTITE CAC SF29(NCO)",
    "GL-ADHESIVE MOR-FREE 698A(NCO)",
    "GL-BRILLANT ADHESIVE S279(NCO)",
    "GL-BRILLIANT ADHESIVE NCO S621(230KG)",
    "GL-BRILLIANT HARDENER S631(OH)",
    "GL-HARDENER LOCTITE CAC SF 29 A( OH)",
    "GL-HARDENER LOCTITE CAC SF29A(OH)",
    "GL-HARDENER MOR FREE C79(OH)",
    "GL-POLYURETHANE RESIN EF2272A",
    "GL-POLYURETHANE RESIN EF2272B",
    "HD ARAMCO",
    "HD CYNPOL Hm 50100",
    "HD EL LENE",
    "HD EXXON",
    "HD LOTTE",
    "HD SABIC",
    "HD SABIC F04660",
    "HD SIBUR",
    "HD YUZER",
    "HD-EXXONMOBILE HTA 108",
    "HDPE",
    "INK - ALPINE MAGENTA",
    "INK -LAMI PLUS MEDIUM",
    "INK -SI 22002 BOPP VERNA WHITE",
    "INK -SI 31501 POLY DF BLACK",
    "INK -SI-32001 POLY DF WHITE",
    "INK ALPHA",
    "INK ALPINE",
    "INK ALPINE BLACK",
    "INK ALPINE BLOOD RED",
    "INK ALPINE FANTA GREEN",
    "INK ALPINE ORANGE",
    "INK ALPINE OVERCOTE",
    "INK ALPINE OVERCOTE MEDIUM",
    "INK AMAZ",
    "INK ASIS",
    "INK BOPP",
    "INK CT BOPP",
    "INK CT BOPP BLACK",
    "INK CT BOPP CYAN",
    "INK CT BOPP GOLD LACQUER",
    "INK CT BOPP MEDIUM",
    "INK CT BOPP NON ARSR MAGENTA",
    "INK CT BOPP OVERCOAT(OPV) MEDIUM",
    "INK CT BOPP SYNTHETIC GOLD",
    "INK CT BOPP WHITE",
    "INK CT BOPP YELLOW",
    "INK CT PET",
    "INK CT POLY",
    "INK CT POLY DF BLOOD RED",
    "INK CT POLY DF CYAN",
    "INK CT POLY DF MAGENTA",
    "INK CT POLY DF ORANGE",
    "INK CT POLY DF YELLOW",
    "INK CT PVC",
    "INK CT PVC RED",
    "INK CT PVC WHITE",
    "INK CT PVC YELLOW",
    "INK PEONY",
    "INK PEONY BLACK",
    "INK PEONY BLOOD RED",
    "INK PEONY MAGENTA",
    "INK PEONY VIOLET",
    "INK PEONY WHITE",
    "INK PET",
    "INK POLY",
    "INK PVC",
    "INK PVC",
    "INK PVC ASIS MEDIUM",
    "INK PVC ASIS ORANGE",
    "INK RAINBOW",
    "INK SI BOPP",
    "INK SI PET",
    "INK SI POLY ",
    "INK-CT BOPP REFLEX BLUE",
    "INK-PEONY SILVER",
    "INK-PVC ASIS MEDIUM",
    "INK-RAIN RS PEBO CYAN",
    "INK-RAIN RS PEBO MEDIUM",
    "INK-RAIN RS PVC MEDIUM",
    "INK-RAINBOW PRINT PEBO WHITE",
    "INK-SI 23011 BOPP BLOOD RED (NEW)",
    "INK-SI PET CYAN BLUE",
    "INK-SI PET MAGENTA",
    "INK-SI PET MEDIUM",
    "INK-SI-10001 PET CYAN BLUE 15:3",
    "INK-SI-10501 PET MAGENTA",
    "INK-SI-10501 PET NON ARSR MAGENTA RED 57:1",
    "INK-SI-11506 PET BLACK",
    "INK-SI-12001 PET WHITE",
    "INK-SI-20001 BOPP CYAN BLUE 15:4",
    "INK-SI-20007 BOPP REFLEX BLUE",
    "INK-SI-2020 BOPP ADDITIVE",
    "INK-SI-20501 BOPP NON ARSR MAGNETA RED 57:1",
    "INK-SI-21001 BOPP YELLOW 13",
    "INK-SI-21501 BOPP BLACK",
    "INK-SI-22001 BOPP WHITE (DRM)",
    "INK-SI-22501 BOPP MEDIUM",
    "INK-SI-23010 BOPP RED CTL",
    "INK-SI-23501 BOPP ORANGE 34",
    "INK-SI-24501 BOPP NON ARSR VIOLET3",
    "INK-SI-2501 PET MEDIUM",
    "INK-SI-25501 BOPP SYNTHETIC GOLD",
    "INK-SI-27001 BOPP OPV MEDIUM ",
    "INK-SI-27501 Synthetic Gold",
    "INK-SI-30001 POLY DF CYAN",
    "INK-SI-30501 POLY DF MAGENTA",
    "INK-SI-31001 POLY DF YELLOW",
    "INK-SI-32001 POLY DF WHITE",
    "INK-SI-32501 POLY DF MEDIUM",
    "INK-SI-33501 POLY DF ORANGE",
    "INK-SI-BOPP BLACK",
    "INK-SI-BOPP YELLOW",
    "IPA 159KG",
    "IPA 160KG",
    "LABEL",
    "LD EXXON",
    "LD INNOPLUS",
    "LD SABIC",
    "LD TASNEE",
    "LD-EXXON 165BW1",
    "LD-EXXONMOBIL 150BW",
    "LD-EXXONMOBILE",
    "LD-LDPE EXXONMOBILE 150AC",
    "LLD EXXON 1001 X BU",
    "LLD LYONDELL BASEL",
    "LLD LYONDELL BASEL GA 1810T",
    "LLD RELENE",
    "LLD SABIC ",
    "LLD SABIC 118WJ",
    "LLD TRICOLENE 1918 SB",
    "LLD YUCLAIR",
    "LLD-CYNPOL",
    "LLD-CYNPOL LL0118H",
    "LLD-CYNPOL LL6118H",
    "LLD-STAR RESIN",
    "LLD-STAR RESIN H1920B(N)",
    "LLDPE",
    "M/B-CPO 83100 WHITE M/B",
    "MAGENTA",
    "MATT BOPP",
    "MATT BOPP [460mm X 18μm]",
    "MATT BOPP [840mm X 20μm]",
    "MATT BOPP [850mm X 18μm]",
    "MATT BOPP[795 X18MU]",
    "MATT BOPP[850 X 18MU]",
    "MATT BOPP[850X18MU]",
    "MATT BOPP[895X18MU]",
    "MATT PET",
    "MET -BOPP [ 945 X18 ]",
    "MET BOPP",
    "MET BOPP [ 980 X18 MU]",
    "MET BOPP [1005mm X 18μm]",
    "MET BOPP [1020mm X 18μm]",
    "MET BOPP [515mm X 15μm]",
    "MET BOPP [755mm X 20μm]",
    "MET BOPP [870mm X 18μm]",
    "MET BOPP [885mm X 18μm]",
    "MET BOPP [895mm X 20μm]",
    "MET BOPP [930mm x 18MU]",
    "MET BOPP [970mm X 18μm]",
    "MET BOPP [975mm X 20μm]",
    "MET BOPP/HAZE",
    "MET BOPP[ 460 X18 MU]",
    "MET BOPP[845mmx18mu]",
    "MET BOPP[855mmx18MU]",
    "MET BOPP[885mm x 18MU]",
    "MET BOPP[930mm x 18MU]",
    "MET BOPP[945X18MU]",
    "MET CPP",
    "MET CPP [580mm X 20μm]",
    "MET CPP [855mm X 20μm]",
    "MET CPP [895mm X 20μm]",
    "MET CPP [975 X 20MU]",
    "MET CPP[720X20MU]",
    "MET CPP[735X25MU]",
    "MET CPP[795X25MU]",
    "MET PET",
    "MET PET [930mm X 12μm]",
    "MET-EXCEED",
    "MET-EXCEED EXXONMOBILE 1018MB",
    "MET-EXCEED S 9243ML NATURAL",
    "MET-EXXONMOBIL EXCEED L1327MA",
    "MET-EXXONMOBILE",
    "MET-LLD EXXON EXCEED",
    "MET-LLD EXXON EXCEED L1327MA",
    "METALIZED [ 755 X20 MU ]",
    "METALIZED [ 755 X20 ]",
    "METALIZED [ 845 X18]",
    "METALIZED [560 X18]",
    "METALIZED[ 795 X18 ]",
    "NAT LDPE",
    "NAT LDPE TUBE",
    "NOMAT-0007010101",
    "NOMAT-0008010101",
    "NOMAT-0009010101",
    "NOMAT-0070101",
    "NOMAT-010101",
    "NOMAT-30050108",
    "NOMAT-30050109010101",
    "NOMAT-40010101",
    "NOMAT-40010102",
    "NOMAT-40010103",
    "NOMAT-40010104",
    "NOMAT-40010105",
    "NOMAT-40010201",
    "NOMAT-41010101",
    "NOMAT-41010102",
    "NOMAT-41020101",
    "NOMAT-41030101",
    "NOMAT-GL -1.3010101",
    "NYLON",
    "PAPER",
    "PAPER CONE CT TUBE (76X10X1000)",
    "PAPER CONE CT TUBE 76X10X1000",
    "Paper pipe tube",
    "PEARLIZED BOPP",
    "PEARLIZED BOPP[820X38MU]",
    "PEARLIZED BOPP[830X38MU]",
    "PET",
    "PET G",
    "PET G [420mm X 40μm]",
    "PET G [560mm X 50μm]",
    "PET G [705mm X 40μm]",
    "PET G [780mm X 40μm]",
    "PET G [815mm X 40μm]",
    "PET G [825 X40 MU]",
    "PET G [980mm X 12μm]",
    "PET G[825 X 45MU]",
    "PET G{420X40 MU}",
    "PET [580 X 12MU]",
    "PET [670mm X 12μm]",
    "PET [980mm X 12μm]",
    "PETG",
    "PETG[775X40MU]",
    "PET[500 X 12MU]",
    "PET[630 X 12MU]",
    "PET[980X12MU]",
    "PLAIN ROLLS"
    ,
    "PRINTED ROLLS",
    "RAW MATERIALS",
    "ROLLS",
    "SF2273B",
    "SF9180A",
    "SF9180B",
    "SHRINK PET",
    "SHRINK PETG",
    "SHRINK PVC",
    "SHRINK-ENABLE 4002MC",
    "SI-67201 PVC WHITE",
    "SOL-1.3 DIOXOLANE",
    "SOL-ETHYL ACETATE",
    "SOL-ETHYL ACETATE 180G",
    "SOL-ETHYL ACETATE 202KG",
    "SOL-ETHYLACETATE 210KG",
    "SOL-METHOXYL PROPANOL",
    "SOL-METHOXYL PROPANOL(190KG)",
    "SOL-N BUTANOL",
    "SOL-N BUTANOL(160KG)",
    "SOL-POLY EA RESINF9180A",
    "SOL-POLY EA RESINF9180B",
    "SOL-POLYURETHANE ",
    "SOL-TETRAHYDROFURAN",
    "SOL-TOLUENE 174KG 456",
    "SOLVENT E/A",
    "SOLVENT EPA",
    "SOLVENT TOLUENE",
    "TETRAHYDROFURAN",
    "TWISTED PVC",
    "TWISTED PVC CLEAR [820mm X 30μm]",
    "TWISTED PVC ORANGE",
    "VIOLET",
    "WHITE BOPP",
    "WHITE LDPE",



];
